<template>
  <div
    class="field"
    style="margin:25px 0">
    <v-container>
      <v-layout
        row
        wrap>
        <v-flex
          xs12
          sm12
          md12
          xl12>
          <v-layout v-if="!this.isForNewAwsAccount">
            <input
              id="file"
              ref="fileupload"
              type="file"
              @change="uploadFile" 
            />
          </v-layout>
          <p>If the request is for multiple DXC staff to get trained by an external party, provide the individual’s details in the below format in an excel file and a valid WBS Code
            (WBS code will be used to set up the users (Approx. 100 to 250 USD) and to charge back if candidates consume beyond the allocated credits)
            First Name, Last Name, Email ID, Manager Name, Region &amp; Country <a href="https://di53zjzskd0oh.cloudfront.net/bulk-upload-template.xlsx" target="_blank">Click here to download template</a></p>
          <v-layout v-if="this.isForNewAwsAccount">
            <input
            id="file"
            ref="fileupload"
            type="file"
            @change="uploadFile" 
            accept=".xlsx, .xls, .csv"/>
            <span class="required">*</span>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12
          xl12>
          <v-btn
            v-if="!this.isForNewAwsAccount"
            :disabled="upload.File===null"
            :loading="upload.loading"
            color="warning"
            @click="sendFile()">Upload File</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- DIALOG -->
    <v-flex justify="center" v-if="!this.isForNewAwsAccount">
      <v-dialog
        v-model="upload.dialog"
        persistent
        max-width="290">
        <v-card>
          <v-card-text><div style="font-weight:600"> You just uploaded <span style="color:orange">{{ upload.filename }}</span>!</div></v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"/>
            <v-btn
              color="orange darken-1"
              text
              @click="clearFileUpload">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </div>

</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  // data: () => ({
  //   senddialog: false
  // }),
  props: {
    isForNewAwsAccount: Boolean
  },
  computed: {
    ...mapState('admin/oppregAdmin', ['upload', 'workload']),
    ...mapState('user/requestAws', ['s3FileUpload'])
  },
  methods: {
    ...mapActions({
      submitDocument: 'admin/oppregAdmin/uploadOppRegDoc'
    }),
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    clearFileUpload () {
      this.$refs.fileupload.value = ''
      this.$store.commit('admin/oppregAdmin/clearFileUpload')
    },
    sendFile () {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'))
      let firstname = currentUser.given_name
      let lastname = currentUser.family_name
      this.upload.uploadedBy = firstname + ' ' + lastname
      this.upload.AWS_Info_Id = this.workload.aws.AWSInfo_id

      this.submitDocument(this.upload)
      // this.senddialog = true
      // const input = this.$refs.fileupload
      // input.type = 'text'
      // input.type = 'file'
    },
    uploadFile (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.upload.FileType = files[0].type

      const toBase64 = file =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })

      toBase64(files[0]).then(values => {
        let fileBase64 = values.split(',').pop()
        this.upload.fileBase = fileBase64
        this.upload.filename = files[0].name
        this.upload.File = files[0]
      })

      if(this.isForNewAwsAccount) {
        this.$store.commit('user/requestAws/setS3File', this.upload)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
form {
  margin: 25px 0 25px 0;
}
</style>
